import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

//Components
import TextField from '../../../../../components/TextField';
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage, showQuestion } from '../../../../../helpers/message';

//Constants
import { actionsTable } from '../../../../../constants/MaterialTable';
import { useAuth } from '../../../../../context/auth';

//API
import integracao_api from '../../../../../api/integracao_api';
import tipoDeFiscalizacao_api from '../../../../../api/tipoDeFIscalizacao_api';

function initialStateOrigemDemanda(tipoDeFiscalizacao_Id) {
  return {
    tipoFiscalizacao_Id: tipoDeFiscalizacao_Id,
    origem: "",
    permiteExecucao: "true",
    integracaoFinalizacao: null,
    callbackIntegracaoRecebidaSucesso: null,
    callbackIntegracaRecebidaFalha: null
  }
}

export default function OrigemDemanda({ tipoDeFiscalizacao, loadTipoDeFiscalizacaoItem, editavel = false }) {
  //State para criar/editar
  const [origemDemanda, setOrigemDemanda] = useState(initialStateOrigemDemanda(tipoDeFiscalizacao.id));

  //state para visibilidade do campos de preenchimentos
  const [visibleForm, setVisibleForm] = useState(false);

  //State pra lista integrações do SAC
  const [integracoesSAC, setIntegracoesSAC] = useState([]);

  //State para pegar erros
  const [errors, setErrors] = useState({});

  const { setLoading } = useAuth();

  //Campos obrigatorios
  const [campos, setCampos] = useState([
    objCampo({ name: "origem", required: true })
  ]);

  const loadResetState = () => {
    setVisibleForm(false);
    loadTipoDeFiscalizacaoItem(tipoDeFiscalizacao.id);
    setOrigemDemanda(initialStateOrigemDemanda(tipoDeFiscalizacao.id));
  }

  //Cabeçalhos da lista de certificados
  const headers = [
    { value: "Origem", objectValue: "origem", align: "left" },
    {
      value: "Permite Execução", objectValue: "permiteExecucao", align: "left", options: {
        customBodyRenderLite: (dataIndex) => {
          return <>{tipoDeFiscalizacao.tipoFiscalizacaoOrigens[dataIndex]?.permiteExecucao ? "Sim" : "Não"}</>
        }
      }
    }
  ];

  const loadIntegracoesSAC = () => {
    setLoading(true);
    integracao_api.GetListIntegracoesSolicitacaoFiscalizacao()
      .then(response => {
        response.data = response?.data?.map(value => {
          value.value = value.id;
          value.label = value.identificacao;
          return value
        })
        setIntegracoesSAC(response?.data)
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    loadIntegracoesSAC()
  }, [])

  //Função para remover editar
  const editar = (rowData) => {
    setVisibleForm(true);
    setOrigemDemanda(rowData);
  }

  const visualizar = (rowData) => {
    setVisibleForm(true);
    setOrigemDemanda(rowData);
  }

  //Função para remover serviço
  const remover = (rowData) => {
    showQuestion("Tem certeza?", "Tem certeza de que deseja deletar essa questão?\n Esta ação é irreversível", "info",
      (confirmation) => {
        if (confirmation) {
          setLoading(true)
          tipoDeFiscalizacao_api.DeleteTipoFiscalizacaoOrigem(rowData.id).then(response => {
            showMessage("Aviso", "Origem fiscalização removido com sucesso", "success", null);
            loadResetState();
          }).catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false))
        }
      })
  }

  //Ações que a tabela terá
  const actions = [
    ...editavel
      ? [actionsTable.editar(editar), actionsTable.remover(remover)]
      : [actionsTable.visualizar(visualizar)]
  ];

  //Função de onChange dos campos
  const onChange = (e) => {
    const { name, value } = e.target;
    const _origemDemanda = {
      ...origemDemanda,
      [name]: value
    };

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campos.filter(campo => campo.name === name);
    const fieldError = validarCampos(_origemDemanda, _campos);

    const _errors = { ...errors };
    delete _errors[name];
    if (fieldError[1].length === 0)
      setErrors({ ..._errors });
    else
      setErrors({ ..._errors, ...fieldError[0] });
    setOrigemDemanda(_origemDemanda);
  }


  const salvarOrigemDemanda = () => {
    const _errors = validarCampos(origemDemanda, campos);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return true;

    const _origemDemanda = { ...origemDemanda };

    if (_origemDemanda.id) {
      setLoading(true)
      tipoDeFiscalizacao_api.putTipoFiscalizacaoOrigem(_origemDemanda).then(response => {
        showMessage("Aviso", "Operação realizada com sucesso", "success", null);
        loadResetState();
      }).catch(err => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false))
    } else {
      setLoading(true)
      tipoDeFiscalizacao_api.postTipoFiscalizacaoOrigem(_origemDemanda).then(response => {
        showMessage("Aviso", "Operação realizada com sucesso", "success", null);
        loadResetState();
      }).catch(err => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false))
    }
  }

  return <>
    <h5 className='mb-3 d-flex align-items-center justify-content-between'>Origem das Demandas {editavel ? <Button color='success' onClick={() => setVisibleForm(!visibleForm)}>+ Adicionar</Button> : <></>}</h5>
    <div className={`formContainer ${!visibleForm ? "close" : "mb-3"}`}>
      <Row>
        <Col md="12" lg={9}>
          <TextField
            name={"origem"}
            label={"* Origem"}
            value={origemDemanda.origem}
            invalid={!!errors.origem}
            onChange={onChange}
            maxLength={100}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg={3}>
          <TextField
            type={"select"}
            label="* Permite Execução"
            name={"permiteExecucao"}
            options={
              [
                { label: "Sim", value: "true" },
                { label: "Não", value: "false" },
              ]
            }
            onChange={onChange}
            value={origemDemanda.permiteExecucao}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg={4}>
          <TextField
            type={"select"}
            label="* Integração Finalização"
            name={"integracaoFinalizacao"}
            searchable
            options={integracoesSAC}
            onChange={(value) => setOrigemDemanda({ ...origemDemanda, integracaoFinalizacao: value ? value.value : null })}
            value={origemDemanda.integracaoFinalizacao != null && integracoesSAC.filter(i => i.id == origemDemanda.integracaoFinalizacao)[0]}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg={4}>
          <TextField
            type={"select"}
            label="* Integração Recebida com Sucesso"
            name={"callbackIntegracaoRecebidaSucesso"}
            searchable
            options={integracoesSAC}
            onChange={(value) => setOrigemDemanda({ ...origemDemanda, callbackIntegracaoRecebidaSucesso: value ? value.value : null })}
            value={origemDemanda.callbackIntegracaoRecebidaSucesso != null && integracoesSAC.filter(i => i.id == origemDemanda.callbackIntegracaoRecebidaSucesso)[0]}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg={4}>
          <TextField
            type={"select"}
            label="* Integração Recebida com Falha"
            name={"callbackIntegracaRecebidaFalha"}
            searchable
            options={integracoesSAC}
            onChange={(value) => setOrigemDemanda({ ...origemDemanda, callbackIntegracaRecebidaFalha: value ? value.value : null })}
            value={origemDemanda.callbackIntegracaRecebidaFalha != null && integracoesSAC.filter(i => i.id == origemDemanda.callbackIntegracaRecebidaFalha)[0]}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
          <Button
            color={origemDemanda.id ? 'warning text-white' : 'success'}
            onClick={salvarOrigemDemanda}
          >
            {origemDemanda.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
          </Button>
        </Col>
      </Row>
    </div>
    <TabelaListagem
      actions={actions}
      title={"Lista de Serviços"}
      headers={headers}
      items={tipoDeFiscalizacao.tipoFiscalizacaoOrigens}
    />
  </>;
}